<template>
  <OrganismAddNewForm></OrganismAddNewForm>
</template>

<script>
import OrganismGallery from "./OrganismGallery";
import OrganismAddNewForm from "../Organism/OrganismAddNewForm";
export default {
  components: { OrganismGallery, OrganismAddNewForm },
  data: () => ({
    organism: {}
  }),
  async mounted() {
    try {
      let { data: organismData } = await this.$http.get(
        "organism/" + this.$route.params.id
      );
      this.organism = organismData;
    } catch (err) {
      console.log(err);
    }
  }
};
</script>

<style></style>
